import React, { useState } from 'react';
import axios from 'axios';
import useNavigateWithBase from "../hooks/useNavigateWithBase"; // ✅ 新しいフックをインポート
import { getRoleName } from '../components/UserRoleBadge'; // UserRoleBadgeを削除
import '../CSS/AddUser.css'; // CSS を適用

const AddUser = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('1.0'); // 初期値は "利用者"
  const [isSubmitting, setIsSubmitting] = useState(false); // 🚀 登録中かどうかの状態
  const [modalData, setModalData] = useState(null); // 🚀 モーダル表示用のデータ
  const navigate = useNavigateWithBase();
  const companyCode = localStorage.getItem('company_code');
  const currentUserRole = parseFloat(localStorage.getItem('role')); // 現在のユーザー権限

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    try {
      const response = await axios.post(
        "https://hmr25alvt7.execute-api.ap-northeast-3.amazonaws.com/prod/api/users",
        {
          action: "add",
          company_code: companyCode,
          user: {
            name: name || "",
            email: email || "",
            role: role !== undefined ? role : 1.0
          }
        },
        { 
          timeout: 30000, // タイムアウトを 30秒 に設定
          withCredentials: false // ✅ CORS エラーを防ぐために追加
        }
      );
  
      if (response.data && response.data.personalId && response.data.password) {
        setModalData({
          personalId: response.data.personalId,
          name: name,
          role: getRoleName(role),
          password: response.data.password || "（パスワードはメールで送信されました）"
        });
      } else {
        console.error("レスポンスに個人IDまたはパスワードが含まれていません:", response.data);
      }
  
    } catch (error) {
      console.error("登録エラー", error);
      if (error.response) {
        console.error("サーバーエラーレスポンス:", error.response.data);
      } else if (error.request) {
        console.error("リクエストは送信されたが応答がありません:", error.request);
      } else {
        console.error("リクエストの設定エラー:", error.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };  

  const handleCloseModal = () => {
    setModalData(null); // 🚀 モーダルを閉じる

    // 🚀 入力フォームをリセット（連続登録可能にする）
    setName('');
    setEmail('');
    setRole('1.0');
  };

  // 現在のログインユーザーの権限以下の選択肢のみを表示
  const availableRoles = [
    { value: 1.0, label: getRoleName(1.0) },
    { value: 5.0, label: getRoleName(5.0) },
    { value: 5.5, label: getRoleName(5.5) },
    { value: 9.0, label: getRoleName(9.0) }
  ].filter(role => role.value <= currentUserRole);

  return (
    <div className="add-user-container">
      <h1 className="add-user-title">新規利用者追加</h1>
      <form className="add-user-form" onSubmit={handleSubmit}>
        <label>名前:</label>
        <input type="text" className="add-user-input" value={name} onChange={e => setName(e.target.value)} required />

        <label>メール:</label>
        <input type="email" className="add-user-input" value={email} onChange={e => setEmail(e.target.value)} />

        <label>権限:</label>
        <select value={role} onChange={e => setRole(e.target.value)}>
          {availableRoles.map(role => (
            <option key={role.value} value={role.value}>{role.label}</option>
          ))}
        </select>

        <div className="add-user-buttons">
          <button type="submit" className="add-user-button submit" disabled={isSubmitting}>
            {isSubmitting ? "データ登録中..." : "追加"}
          </button>
          <button type="button" className="back-button cancel" onClick={() => navigate('/portal')} disabled={isSubmitting}>
            ポータルへ戻る
          </button>
        </div>
      </form>

      {/* 🚀 モーダルウィンドウ */}
      {modalData && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>登録成功！</h2>
            <p><strong>個人ID:</strong> {modalData.personalId}</p>
            <p><strong>ユーザー名:</strong> {modalData.name}</p>
            <p><strong>権限:</strong> {modalData.role}</p>
            <p><strong>パスワード:</strong> {modalData.password}</p>
            <button className="modal-button" onClick={handleCloseModal}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddUser;
